'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';
export const ChatRuntimeContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") ChatRuntimeContext.displayName = "ChatRuntimeContext";
export function useChatRuntimeContext(optional = false) {
  const context = React.useContext(ChatRuntimeContext);
  if (context == null && !optional) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Chat: useChatRuntimeContext must be used within a <ChatProvider> component' : _formatErrorMessage(255));
  }
  return context;
}